export default function Stepper({ etapaAtual = 1 }) {
  const totalEtapas = 3;
  const progresso = (etapaAtual / totalEtapas) * 100;

  const textoEtapa = `Etapa ${String(etapaAtual).padStart(2, "0")}`;

  return (
    <div className="stepper-wrapper">
      <div className="stepper-label">{textoEtapa}</div>

      <div className="stepper-bar">
        <div
          className="stepper-progress"
          style={{ width: `${progresso}%` }}
        />
      </div>
    </div>
  );
}
